export const ldClientId = '645e932a984b3a152396d364';
export const ldClientProdId = '645e92d426e615119ab21f99';
